export default "__VITE_ASSET__BwmTouKD__"